import { render, staticRenderFns } from "./TaskPopup.vue?vue&type=template&id=b72afdaa&scoped=true"
import script from "./TaskPopup.vue?vue&type=script&lang=ts"
export * from "./TaskPopup.vue?vue&type=script&lang=ts"
import style0 from "./TaskPopup.vue?vue&type=style&index=0&id=b72afdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72afdaa",
  null
  
)

export default component.exports